// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from '../core/BaseButton';
import UIButton from '../core/components/UIButton';
/* START-USER-IMPORTS */
import { PlayerController } from '../PlayerController';
/* END-USER-IMPORTS */

export default class BtnJump extends BaseButton {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 68.5, y ?? 72.5);

    // btn
    const btn = scene.add.image(0, 0, 'common', 'btn-endscreen.png');
    this.add(btn);

    // iconJump
    const iconJump = scene.add.image(0, 0, 'common', 'icon-jump.png');
    this.add(iconJump);

    // btnKeyboard
    const btnKeyboard = scene.add.image(-77, 32, 'common', 'btn-keyboard.png');
    btnKeyboard.visible = false;
    this.add(btnKeyboard);

    // iconSpacebar
    const iconSpacebar = scene.add.image(-99, 32, 'common', 'btn-keyboard-space.png');
    iconSpacebar.scaleX = 0.75;
    iconSpacebar.scaleY = 0.75;
    this.add(iconSpacebar);

    // lists
    const desktopVisibleList = [iconSpacebar];
    const mobileVisibleList: Array<any> = [];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.desktopVisibleList = desktopVisibleList;
    thisUIButton.mobileVisibleList = mobileVisibleList;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 1000;

    this.desktopVisibleList = desktopVisibleList;
    this.mobileVisibleList = mobileVisibleList;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private desktopVisibleList: Phaser.GameObjects.Image[];
  private mobileVisibleList: Array<any>;

  /* START-USER-CODE */

  public awake() {
    this.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.scene.events.emit(PlayerController.events.StartJump);
    });

    this.on(Phaser.Input.Events.POINTER_UP, () => {
      this.scene.events.emit(PlayerController.events.EndJump);
    });

    this.on(Phaser.Input.Events.POINTER_OUT, () => {
      this.scene.events.emit(PlayerController.events.EndJump);
    });
  }

  public destroy(fromScene?: boolean | undefined): void {
    this.off(Phaser.Input.Events.POINTER_DOWN);
    this.off(Phaser.Input.Events.POINTER_UP);
    this.off(Phaser.Input.Events.POINTER_OUT);

    super.destroy(fromScene);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
